import * as A11yDialog from 'a11y-dialog/a11y-dialog.js';

const hydrateModal = () => {
    const header = (window as any).deletionHeader;
    const contentInUse = (window as any).deletionContentInUse;
    const contentNotInUse = (window as any).deletionContentNotInUse;
    const headerContainer = document.querySelector('[data-deletion-header]') as HTMLElement;
    const contentContainer = document.querySelector('[data-deletion-content]') as HTMLElement;
    headerContainer.innerHTML = header;
    contentContainer.innerHTML = `<p data-in-use>${contentInUse}</p><p data-not-in-use>${contentNotInUse}</p>`;
}

const deletionModal = document.querySelector('[data-deletion-modal]') as HTMLElement;
if (deletionModal) {
    hydrateModal();
    const deletionModalInstance = new A11yDialog(deletionModal);
    const deleteButtons = [].slice.call(document.querySelectorAll('[data-text="Delete"]:not([ng-click])')) as HTMLAnchorElement[];
    deleteButtons.forEach(deleteButton => {
        let confirmed = false;
        deleteButton.addEventListener('click', (e: MouseEvent) => {
            if (!confirmed) {
                e.preventDefault();
                const isInUse = (deleteButton.getAttribute('data-item-in-use')?.toLowerCase()) || "false";
                deletionModal.setAttribute('data-item-in-use', isInUse);
                deletionModalInstance.show();
                const confirmButton = deletionModal.querySelector('[data-deletion-confirm]') as HTMLButtonElement;

                const confirmHandler = () => {
                    confirmed = true;
                    deleteButton.click();
                    deletionModal.classList.add('loading');
                }
                // prevent dupe listeners
                confirmButton.removeEventListener('click', confirmHandler);
                confirmButton.addEventListener('click', confirmHandler);
            }
        })
    })
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./Frontend/javascript/common/deletion-modal.ts